const individual_operational_hours = (data) => {
  const daysOfWeek = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
  const startDateTime = new Date(data.startTime);
  const endDateTime = new Date(data.endTime);
  const normalized: any = [];

  // Find the index of the dayFrom and dayTo in daysOfWeek
  let fromIndex = daysOfWeek.indexOf(data.dayFrom);
  let toIndex = daysOfWeek.indexOf(data.dayTo);

  // If user sets Sunday -> Tuesday, rearrange array
  let toArrange = false; // if set to true, the daysOfWeek has been rearranged
  let arrangedDaysOfWeek: any = [];

  if (toIndex < fromIndex) {
    // push from fromIndex to (daysOfWeek.length - 1)
    for (let i = fromIndex; i <= daysOfWeek.length - 1; i++) {
      arrangedDaysOfWeek.push(daysOfWeek[i]);
    }

    // push from 0 to toIndex
    for (let i = 0; i <= toIndex; i++) {
      arrangedDaysOfWeek.push(daysOfWeek[i]);
    }

    // set to true, and readjust fromIndex and toIndex to reference arrangedDaysOfWeek
    toArrange = true;
    fromIndex = 0;
    toIndex = arrangedDaysOfWeek.length - 1;
  }

  for (let i = fromIndex; i <= toIndex; i++) {
    const day = toArrange ? arrangedDaysOfWeek[i] : daysOfWeek[i];
    const openingTime = new Date(startDateTime);
    const closingTime = new Date(endDateTime);

    // Set the time portion of openingTime and closingTime to 0
    // openingTime.setHours(0, 0, 0, 0);
    // closingTime.setHours(0, 0, 0, 0);

    // // If it's the first day, set the opening time to the start time
    // if (i === fromIndex) {
    //   openingTime.setHours(startDateTime.getHours(), startDateTime.getMinutes());
    // }

    // // If it's the last day, set the closing time to the end time
    // if (i === toIndex) {
    //   closingTime.setHours(endDateTime.getHours(), endDateTime.getMinutes());
    // }

    normalized.push({
      day,
      openingTime: openingTime.toISOString(),
      closingTime: closingTime.toISOString(),
    });
  }

  return normalized;
};

export default individual_operational_hours;
